import styled, { css } from 'styled-components/macro'
import { button as textstyle } from 'styles/mixins/textstyles'
import { Link } from 'react-router-dom'
import { ExternalLink } from 'components/layout/links'
import palette from 'styles/palette'

function primary() {
  return css`
    ${(props) => textstyle(props.theme.colors.white)}
    display: block;
    width: ${(props) => (props.width ? props.width : '100%')};
    transition: all 150ms ease;
    padding: 1.5rem;
    background: ${palette('Base')};
    border: 1px solid ${palette('Base')};
    border-radius: 5px;
    text-align: center;
    cursor: pointer;

    &:hover {
      background: ${palette('Darker')};
      border-color: ${palette('Darker')};
      color: ${(props) => props.theme.colors.white};
    }

    &[disabled] {
      background: ${(props) => props.theme.colors.greyLight};
      border-color: ${(props) => props.theme.colors.greyLight};
      color: ${(props) => props.theme.colors.greyDark} !important;
    }
  `
}

function secondary() {
  return css`
    ${primary()}

    background: none;
    color: ${palette('Base')};
  `
}

function tertiary() {
  return css`
    ${(props) => textstyle(palette('Base')(props))}
    border: none;
    cursor: pointer;
    outline: none;
    background: none;
    padding: 0;

    &:hover {
      ${(props) => textstyle(palette('Darker')(props))}
    }

    &[disabled] {
      color: ${(props) => props.theme.colors.greyLight};
    }
  `
}

function textstyleOnly() {
  return css`
    ${(props) => textstyle(palette('Base')(props))}
  `
}

function getMixin(mode) {
  switch (mode) {
    case 'primary':
      return primary
    case 'secondary':
      return secondary
    case 'textstyle-only':
      return textstyleOnly
    default:
      return tertiary
  }
}

// Raw component class that can be used as a base to be restyled in styled-components

export function buttonComponent(element, mode = 'tertiary') {
  const mixin = getMixin(mode)
  return styled(element)`
    ${mixin()}
  `
}

// Polymorphic Button class
//  -- the styling gets created at render so it cannot be overridden by styled components
//  -- use `buttonComponent` in that case.

// const Button = props => {
//   const { element, mode, ...remianingProps } = props

//   const Comp = buttonComponent(element, mode)

//   return <Comp {...remianingProps} />
// }

function makeButton(element) {
  return styled(element)`
    ${(props) => getMixin(props.mode)}
  `
}

// HTML BUTTON

// export const BasicButton = props => <Button element="button" {...props} />
export const BasicButton = makeButton('button')

// ANCHOR

// export const AnchorButton = props => <Button element={ExternalLink} {...props} />
export const AnchorButton = makeButton(ExternalLink)

// REACT ROUTER LINK

// export const LinkButton = props => <Button element={Link} {...props} />
export const LinkButton = makeButton(Link)

// DIV BUTTON

// export const DivButton = props => <Button element="div" {...props} />
export const DivButton = makeButton('div')

// External link button

// export const ExternalLinkButton = props => <Button element="a" {...props} />
export const ExternalLinkButton = makeButton('a')
